<template>


<!-- <h1 v-show="initialProjects">initialProjects</h1>
<h1 v-show="showServiceTopic">showServiceTopic</h1>
<h1 v-show="showAllSelected">showAllSelected</h1>
<h1 v-show="showServiceStatus">showServiceStatus</h1> -->

  <section class="projects-wrap" id="projects-wrap">
    <form role="search" id="publications-search" class="form-inline form-search form-search--publication searchform">
      <input
  class="form-control onpage-control"
  type="text"
  placeholder="Search DO Projects"
  v-model="search_input"
  @change="onSearchInput" />
      

    </form>
    
    <div class="row filter filter--projects">

      <div class="col-md-10">

        <nav class="navbar-filter">

          <ul class="nav-filter" id="do-filters">

              <!-- <p v-if="servicesLoading"></p> -->
              <div class="lds-spinner-do-small text-center" v-if="servicesLoading || topicsLoading || statusLoading"></div>


              <template v-else>
                
                <!-- {{servicesResult}} 
                {{computedServiceTerms}} -->
                <DropdownItems
                  :clear="true"
                  class="nav-filter__item dropdown do-filter-services doDropdown"
                  :options="servicesResult.servicesTerms.nodes"
                  :key="servicesResult.servicesTerms.nodes.name"
                  :selected="projectServices"
                  placeholder="Services"
                  v-on:updateOption="serviceSelect">
                </DropdownItems>
                
                <DropdownItems
                  :clear="true" class="nav-filter__item dropdown do-filter-topics" 
                  :options="topicsResult.topics.nodes"
                  :selected="projectTopics"
                  placeholder="Topics"
                  v-on:updateOption="topicSelect"></DropdownItems>

                <!-- {{projectStatus}} -->

                <DropdownItems

                  :clear="true" class="nav-filter__item dropdown do-filter-status" 
                  :options="statusResult.statuses.nodes"
                  :selected="projectStatus"
                  placeholder="Status"
                  v-on:updateOption="statusSelect"></DropdownItems>

              </template>

          </ul>

        </nav>

      </div>

      <div class="col-md-2">

        <div class="filter-view " id="toggle-grid">

          <a id="full-view" class="filter-view__link is-active" href="#">

            <img src="https://www.scattergoodfoundation.org/wp-content/themes/scattergood/img/list-sm-dark.png">

          </a>

          <a id="grid-view" class="filter-view__link" href="#">

            <img src="https://www.scattergoodfoundation.org/wp-content/themes/scattergood/img/grid-sm-dark.png">

          </a>

        </div>

      </div>

    </div>

    <div class="projects" id="results-view">

      <div class="box-publications">

        <div v-show="initialProjects" class="pre-results searchwp-live-search-results" style="text-align:left;">
            
            <!-- <p v-if="allSelectedLoading"></p> -->
            <div class="lds-spinner-do text-center" v-if="allSelectedLoading"></div>

            <template v-else>
              <!-- <pre>{{allSelectedResult}}</pre> -->
              <!-- length = {{allSelectedResult.projects.nodes.length}} -->
              <!-- {{computedServicesResult}}-->
              <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="allSelectedResult.projects.nodes.length == 0">
              No Results Found
              </p>
              <template v-for="(project, index) in allSelectedResult.projects.nodes" :key="project">
                  <!-- <pre>{{project}}</pre> -->
                  <a v-if="index < publicationsToShow" class="item-wrap" v-bind:href="project.link">

                    <div class="slider-do__wrap matchme">

                      <div class="row row--first">

                        <div class="col grid-col">

                          <div class="slider-do__img vue-bgimage" v-if="project.moduleSystem.featuredImage"
                          :style="{ 'background-image': bgImage(project.moduleSystem.featuredImage.mediaItemUrl) }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />

                          </div>

                        </div>

                        <div class="col">

                          <div class="slider-do__text">

                            <h6 class="d-none d-md-block">{{project.moduleSystem.status.name}}</h6>

                            <hr class="hr hr-sm hr-left hr-blue hr-list">

                            <h2 class="clampable" style="display: none;">{{project.title}}</h2>

                            <h2>{{project.title}}</h2>

                            <hr class="hr hr-sm hr-left hr-blue hr-grid">

                            <p class="d-none d-md-block">{{project.moduleSystem.projectsHeroDescription}}</p>

                          </div>

                        </div>

                        <div class="col list-col">

                          <div class="slider-do__img vue-bgimage" v-if="project.moduleSystem.featuredImage"
                           :style="{ 'background-image': bgImage(project.moduleSystem.featuredImage.mediaItemUrl) }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />
                        
                          </div>
                        </div>
                      </div>
                      <div class="row row--last">
                        <div class="col">
                          <div class="slider-do__box">
                            <h2>Partners</h2>

                            <template v-if="project.moduleSystem.partner[0]">
                              <img v-bind:src="imgageUrl(project.moduleSystem.partner[0].partners.partnerLogoDark.mediaDetails.sizes[2].sourceUrl)" >
                            </template>

                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Service</h2>
                            <p :v-if="project.servicesTerms.nodes.name">{{project.servicesTerms.nodes[0].name}}</p>
                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Topic</h2>

                            <p v-for="topic in project.topics.nodes" :key="topic">{{topic.name}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
              
              </template>

              <template v-if="allSelectedResult.projects.nodes.length > publicationsToShow">
                    <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
              </template>

            </template>

        </div>

        <div v-show="showServiceTopic" class="pre-results searchwp-live-search-results" style="text-align:left;">
            
            <!-- <p v-if="serviceTopicLoading"></p> -->
            <div class="lds-spinner-do text-center" v-if="serviceTopicLoading"></div>


            <template v-else>
              <!-- {{initialProjectsResult}} -->
              <!-- {{computedServicesResult}} -->
              <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="serviceTopicResult.projects.nodes == 0">
              No Results Found
              </p>
              <template v-for="(project,index) in serviceTopicResult.projects.nodes" :key="project">

                  <a v-if="index < publicationsToShow" class="item-wrap" v-bind:href="project.link">

                    <div class="slider-do__wrap matchme">

                      <div class="row row--first">

                        <div class="col grid-col">

                          <div class="slider-do__img" v-if="project.moduleSystem.featuredImage"
                            :style="{ 'background-image': 'url(' + project.moduleSystem.featuredImage.mediaItemUrl + ');' }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />

                          </div>

                        </div>

                        <div class="col">

                          <div class="slider-do__text">

                            <h6 class="d-none d-md-block">{{project.moduleSystem.status.name}}</h6>

                            <hr class="hr hr-sm hr-left hr-blue hr-list">

                            <h2 class="clampable" style="display: none;">{{project.title}}</h2>

                            <h2>{{project.title}}</h2>

                            <hr class="hr hr-sm hr-left hr-blue hr-grid">

                            <p class="d-none d-md-block">{{project.moduleSystem.projectsHeroDescription}}</p>

                          </div>

                        </div>

                        <div class="col list-col">

                          <div class="slider-do__img" v-if="project.moduleSystem.featuredImage"
                            :style="{ 'background-image': 'url(' + project.moduleSystem.featuredImage.mediaItemUrl + ');' }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />
                        
                          </div>
                        </div>
                      </div>
                      <div class="row row--last">
                        <div class="col">
                          <div class="slider-do__box">
                            <h2>Partners</h2>

                            <template v-if="project.moduleSystem.partner[0]">
                              <img v-bind:src="imgageUrl(project.moduleSystem.partner[0].partners.partnerLogoDark.mediaDetails.sizes[2].sourceUrl)" >
                            </template>

                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Service</h2>
                            <p :v-if="project.servicesTerms.nodes.name">{{project.servicesTerms.nodes[0].name}}</p>
                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Topic</h2>
                            <p v-if="project.moduleSystem.topic">{{project.topics.nodes.name}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>

              </template>
              <template v-if="serviceTopicResult.projects.nodes.length > publicationsToShow">
                    <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
              </template>

            </template>

        </div>

        <div v-show="showAllSelected" class="pre-results searchwp-live-search-results" style="text-align:left;">
            
            <!-- <p v-if="showAllSelectedLoading"></p> -->
            <div class="lds-spinner-do text-center" v-if="showAllSelectedLoading"></div>

            <template v-else>
              <!-- {{showAllSelectedResult}} 
              {{showAllSelectedError}} -->
              <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="showAllSelectedResult.projects.nodes.length == 0">
              No Results Found
              </p>
              
              <template v-for="(project,index) in showAllSelectedResult.projects.nodes" :key="project">

                  <a v-if="index < publicationsToShow" class="item-wrap" v-bind:href="project.link">

                    <div class="slider-do__wrap matchme">

                      <div class="row row--first">

                        <div class="col grid-col">

                          <div class="slider-do__img" v-if="project.moduleSystem.featuredImage"
                            :style="{ 'background-image': 'url(' + project.moduleSystem.featuredImage.mediaItemUrl + ');' }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />

                          </div>

                        </div>

                        <div class="col">

                          <div class="slider-do__text">

                            <h6 class="d-none d-md-block">{{project.moduleSystem.status.name}}</h6>

                            <hr class="hr hr-sm hr-left hr-blue hr-list">

                            <h2 class="clampable" style="display: none;">{{project.title}}</h2>

                            <h2>{{project.title}}</h2>

                            <hr class="hr hr-sm hr-left hr-blue hr-grid">

                            <p class="d-none d-md-block">{{project.moduleSystem.projectsHeroDescription}}</p>

                          </div>

                        </div>

                        <div class="col list-col">

                          <div class="slider-do__img" v-if="project.moduleSystem.featuredImage"
                            :style="{ 'background-image': 'url(' + project.moduleSystem.featuredImage.mediaItemUrl + ');' }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />
                        
                          </div>
                        </div>
                      </div>
                      <div class="row row--last">
                        <div class="col">
                          <div class="slider-do__box">
                            <h2>Partners</h2>

                            <template v-if="project.moduleSystem.partner[0]">
                              <img v-bind:src="imgageUrl(project.moduleSystem.partner[0].partners.partnerLogoDark.mediaDetails.sizes[2].sourceUrl)" >
                            </template>

                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Service</h2>
                            <p :v-if="project.servicesTerms.nodes.name">{{project.servicesTerms.nodes[0].name}}</p>
                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Topic</h2>
                            <p v-if="project.moduleSystem.topic">{{project.topics.nodes.name}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>

              </template>
              
              <template v-if="showAllSelectedResult.projects.nodes.length > publicationsToShow">
                    <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
              </template>


            </template>

        </div>


        <div v-show="showServiceStatus" class="pre-results searchwp-live-search-results" style="text-align:left;">
            
            <!-- <p v-if="serviceStatusLoading"></p> -->
            <!-- {{serviceStatusError}} -->
            <div class="lds-spinner-do text-center" v-if="serviceStatusLoading"></div>


            <template v-else>
              <!-- {{serviceStatusResult}}
              {{serviceStatusError}} -->
              <p class="no-results-found text-center position-absolute" style="z-index:999; background-color: transparent; width: 100%;" v-if="serviceStatusResult.projects.nodes.length == 0">
              No Results Found
              </p>
              <template v-for="(project,index) in serviceStatusResult.projects.nodes" :key="project">

                  <a v-if="index < publicationsToShow" class="item-wrap" v-bind:href="project.link">

                    <div class="slider-do__wrap matchme">

                      <div class="row row--first">

                        <div class="col grid-col">

                          <div class="slider-do__img" v-if="project.moduleSystem.featuredImage"
                            :style="{ 'background-image': 'url(' + project.moduleSystem.featuredImage.mediaItemUrl + ');' }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />

                          </div>

                        </div>

                        <div class="col">

                          <div class="slider-do__text">

                            <h6 class="d-none d-md-block">{{project.moduleSystem.status.name}}</h6>

                            <hr class="hr hr-sm hr-left hr-blue hr-list">

                            <h2 class="clampable" style="display: none;">{{project.title}}</h2>

                            <h2>{{project.title}}</h2>

                            <hr class="hr hr-sm hr-left hr-blue hr-grid">

                            <p class="d-none d-md-block">{{project.moduleSystem.projectsHeroDescription}}</p>

                          </div>

                        </div>

                        <div class="col list-col">

                          <div class="slider-do__img" v-if="project.moduleSystem.featuredImage"
                            :style="{ 'background-image': 'url(' + project.moduleSystem.featuredImage.mediaItemUrl + ');' }">

                            <img class="desktop" v-if="project.moduleSystem.featuredImage"
                              v-bind:src="imgageUrl(project.moduleSystem.featuredImage.mediaItemUrl)" />
                        
                          </div>
                        </div>
                      </div>
                      <div class="row row--last">
                        <div class="col">
                          <div class="slider-do__box">
                            <h2>Partners</h2>

                            <template v-if="project.moduleSystem.partner[0]">
                              <img v-bind:src="imgageUrl(project.moduleSystem.partner[0].partners.partnerLogoDark.mediaDetails.sizes[2].sourceUrl)" >
                            </template>

                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Service</h2>
                            <p :v-if="project.servicesTerms.nodes.name">{{project.servicesTerms.nodes[0].name}}</p>
                          </div>
                        </div>
                        <div class="col d-none d-md-block">
                          <div class="slider-do__box">
                            <h2>Topic</h2>
                            <p v-if="project.moduleSystem.topic">{{project.topics.nodes.name}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>

              </template>
              <template v-if="serviceStatusResult.projects.nodes.length > publicationsToShow">
                    <button class="btn btn-md btn-white btn-center load-publications" @click="showMoreResults">Load More</button>
              </template>

            </template>

        </div>

      </div>

      <!-- <button class="btn btn-md btn-white btn-center load-do-projects">Load More</button> -->

    </div>

  </section>

</template>

<script setup>

import { ref, computed, watchEffect } from "vue";
import { useQuery } from "@vue/apollo-composable";
import gql from "graphql-tag";
// import { empty } from "@apollo/client/core";
import { useDebouncedRef } from './debouncedRef'


// :::::::::::::::::::::: Import filter query files ::::::::::::::::::::::
import servicesTaxQuery from '../graphql/filterOptions/servicesTaxonomy.gql'
import topicsTaxonomy from '../graphql/filterOptions/topicsTaxonomy.gql'
import statusTaxonomy from '../graphql/filterOptions/statusTaxonomy.gql'


// :::::::::::::::::::::: Import results query files ::::::::::::::::::::::
//initial
import initialProjectsQuery from '../graphql/results/initialProjectsQuery.gql'
//ALL
import showAllSelectedQuery from '../graphql/results/resultAllSelected.gql'
//Service
import resultServiceOnly from '../graphql/results/resultServiceOnly.gql'
//Topic
import topicOnlyQuery from '../graphql/results/resultTopicOnly.gql'
//Status
import statusOnlyQuery from '../graphql/results/resultStatusOnly.gql'


//duplicates
import topicStatusQuery from '../graphql/results/resultTopicStatus.gql'
import serviceStatusQuery from '../graphql/results/resultServiceStatus.gql'
import serviceTopicQuery from '../graphql/results/resultServiceTopic.gql'


//import components
import DropdownItems from '../components/DropdownItems.vue';

const initialServices = [ "66", "247", "117", "122", "65", "82", "64", "63" ];
let projectServices = ref([ "66", "247", "117", "122", "65", "82", "64", "63" ]);
let publicationsToShow = ref(6);
let projectTopics = ref('');
let projectStatus = ref('');
let search_input = useDebouncedRef('');
let initialProjects = ref(true)
let showServiceTopic = ref(false)
let showServiceStatus = ref(false)
let showTopicOnly = ref(false)
let showTopicStatus = ref(false)
let showStatusOnly = ref(false)
let showAllSelected = ref(false)

let renderComponent = ref(true)

const serviceSelect = (payload) => {
  
  if(payload.termTaxonomyId){
  
    projectServices.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log( projectServices )
    
  } else {
    console.log('notaxID');
    projectServices.value = initialServices;
    optionsCheck()
  }

}

const topicSelect = (payload) => {
  // projectTopics.value = payload.termTaxonomyId.toString()
  // optionsCheck()


  if(payload.termTaxonomyId){
  
    projectTopics.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log( projectServices )
    
  } else {
    console.log('notaxID');
    projectTopics.value = '';
    optionsCheck()
  
  }


}

const forceRerender = () => {
  this.renderComponent = false;
  this.$nextTick(()=> {

    this.renderComponent = true;

  })
}

const statusSelect = (payload) => {
  // projectStatus.value = payload.termTaxonomyId.toString()
  // optionsCheck()

  if(payload.termTaxonomyId){
  
    projectStatus.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log( projectServices )
    
  } else {
    console.log('notaxID');
    projectStatus.value = '';
    optionsCheck()
  }



}



const imgageUrl = (imageSrc) => {
  return imageSrc;
}

const bgImage = (image) => {
  
  // console.log( image )
  return `url("${image}")`;

}



// const onClearFilters = () => {
 
//     projectServices.value = ''
//     optionsCheck()
//     console.log( projectServices.value )

// }

const optionsCheck = () => {
  console.log( projectServices );
  let service = projectServices.value.length !== 0 ? true : false;
  let topic = projectTopics.value.length !== 0 ? true : false;
  let status = projectStatus.value.length !== 0 ? true : false;

  if (service == true && topic == false && status == false) {
    console.log('service only')
    initialProjects.value = true
    showServiceTopic.value = false
    showAllSelected.value = false 
    showServiceStatus.value = false 
  }

  else if (service == true && topic == true && status == false) {
    console.log('service and topic')
    initialProjects.value = false
    showServiceTopic.value = true
    showAllSelected.value = false 
    showServiceStatus.value = false 
    
  }

  else if (topic == true && status == false && service == false) {
    console.log('topic only')
    console.log( topicOnlyVariables.value )
    // topicOnlyQuery
    // topicOnlyResult
  }

  else if (topic == true && status == true && service == false) {
    console.log('topic and status')
    console.log( topicStatusVariables.value )
    // resultTopicStatus
    // topicStatusResult
  }

  else if (status == true && service == false && topic == false) {
    console.log('status only')
    console.log( statusOnlyVariables.value )
    // statusOnlyQuery
    // statusOnlyResult
  }

  else if (status == true && service == true && topic == false) {
    console.log('status and service')
    console.log( serviceStatusVariables.value )
    initialProjects.value = false
    showServiceTopic.value = false
    showAllSelected.value = false 
    showServiceStatus.value = true 
    // resultServiceStatus
    // serviceStatusResult
  }

  else if (service == true && topic == true && status == true) {
    
    console.log('all selected')
    console.log( allSelectedVariables.value )
    
    initialProjects.value = false
    showServiceTopic.value = false
    showAllSelected.value = true 
    showServiceStatus.value = false 
    // allSelectedQuery
    // allSelectedResult
  }

  else {
    console.log('nothing selected');
    // console.log( initialProjectsVariables.value )
    // initialProjectsResult
  } 

}

const showMoreResults = () => {
  publicationsToShow.value = publicationsToShow.value + 6;
}


const onSearchInput = (e) => {
  this.search_input.value = e.target.value;
}
const onTaxInput = (e) => {
  this.tax_input.value = e.target.value;
}  


//  :::::::::::::::::::::: Import filter queries ::::::::::::::::::::::
/**
 * Get Project Services for Filters
 **/

const { result: servicesResult, loading: servicesLoading, error: servicesError, options: servicesOptions, variables: servicesVariables
} = useQuery( servicesTaxQuery );


/**
* Get Project Topics for Filters
**/

const { result: topicsResult,loading: topicsLoading, error: topicsError, options: topicsOptions, variables: topicsVariables } = useQuery( topicsTaxonomy );


/**
 * Get Project Status for Filters
 **/

const { result: statusResult, loading: statusLoading, error: statusError, options: statusOptions, variables: statusVariables } = useQuery( statusTaxonomy );

//   :::::::::::::::::::::: Import Results queries ::::::::::::::::::::::
/**
 * Get initial projects result
 **/



const { result: allSelectedResult, loading: allSelectedLoading, error: allSelectedError, options: allSelectedOptions, variables: allSelectedVariables, refetch: allSelectedRefetch 

} = useQuery( initialProjectsQuery, 
  
  {
    service: projectServices,
    search_input: search_input,



  }
  );

// const results = computed (() => result.value?.projects ?? [])

const computedServiceTerms = computed (() => projectServices.value )

watchEffect(() => {



})

  //   query NewQuery($where: RootQueryToProjectConnectionWhereArgs = {taxQuery: {taxArray: {taxonomy: PROJECTTYPE, terms: "7"}}} ) {
  //   projects(where: $where) {
  //     nodes {
  //       title
  //     }
  //   }
  // }
// initialProjectsQuery 
// allselected
/**
 * Get allSelected
 **/

const { result: showAllSelectedResult, loading: showAllSelectedLoading, error: showAllSelectedError, options: showAllSelectedOptions, variables: showAllSelectedVariables, refetch: showAllSelectedRefetch } = useQuery( showAllSelectedQuery, { service: projectServices, topic: projectTopics, status:projectStatus, search_input: search_input } );


//service only
/**
 * Get ServiceOnlyResult
 **/

const { result: serviceOnlyResult, loading: serviceOnlyLoading, error: serviceOnlyError, options: serviceOnlyOptions, variables: serviceOnlyVariables, refetch: serviceOnlyRefetch } = useQuery( resultServiceOnly, { service: projectServices,search_input: search_input } );



// service topic
/**
 * Get ServiceTopicResult
 **/
const { result: serviceTopicResult, loading: serviceTopicLoading, error: serviceTopicError, options: serviceTopicOptions, variables: serviceTopicVariables, refetch: serviceTopicRefetch } = useQuery( serviceTopicQuery, { service: projectServices, topic: projectTopics,search_input: search_input } );


// service status
/**
 * Get ServiceStatusResult
 **/
const { result: serviceStatusResult, loading: serviceStatusLoading, error: serviceStatusError, options: serviceStatusOptions, variables: serviceStatusVariables, refetch: serviceStatusRefetch } = useQuery( serviceStatusQuery, { service: projectServices, status: projectStatus,search_input: search_input } );



// topic alone
/**
 * Get Topic Only 
 **/
const { result: topicOnlyResult, loading: topicOnlyLoading, error: topicOnlyError, options: topicOnlyOptions, variables: topicOnlyVariables, refetch: topicOnlyRefetch } = useQuery( topicOnlyQuery, { topic: projectTopics,search_input: search_input } );



// topic status
/**
 * Get Topic Status 
 **/
const { result: topicStatusResult, loading: topicStatusLoading, error: topicStatusError, options: topicStatusOptions, variables: topicStatusVariables, refetch: topicStatusRefetch } = useQuery( topicStatusQuery, { status: projectStatus, topic: projectTopics,search_input: search_input } );


// status alone
/**
 * Get Status Alone
 **/
const { result: statusOnlyResult, loading: statusOnlyLoading, error: statusOnlyError, options: statusOnlyOptions, variables: statusOnlyVariables, refetch: statusOnlyRefetch } = useQuery( statusOnlyQuery, { status: projectStatus,search_input: search_input } );






/**
 * Make sure that services have the name element available for the dropdown item component
 * so map the initial result with a .name element and poulate the dropdown
 **/ 
const computedServicesResult = computed(() => {

  const returnServices = servicesResult.value.servicesTerms.nodes.map((element, index) => ({
    ...element,
    name: element.name
  })

  );



  /**
   * cases:
   *
   * 
        service alone
        service topic
        topic alone
        topic status
        status alone
        status service
        service topic status

    */

   //Check cases to use queries
// console.clear()


  
  // console.log(returnServices);
  
  return returnServices;

})


let validResultsLoaded = ref(false);
let validResultsForLoop = ref({})

// const validResults = computed(() => {
  
//   let _years=[]
  
//   this.$set.validResultsLoaded = 'ass';
  
//   return _years;

// })

// watchEffect(() => {
  
//   if( computedSelectResults.value !== false ){
  
//   console.log('we have computed select results')
//   validResultsLoaded = true
//   validResultsForLoop = computedSelectResults.value
//   console.log( validResultsForLoop )
  
//   } else {


//     console.log( 'else' )
//     validResultsLoaded = true
//     console.log( computedSelectResults )

//   }
// },{ deep: true })

// watch( [computedSelectResults, projectServices, projectTopics, projectStatus],
// ([computedSelectResultsNew, projectServicesNew, projectTopicsNew, projectStatusNew ], [ prevValidcomputedSelectResults,prevProjectServices, prevProjectTopics, prevProjectStatus ]) => {
//   /* ... */
// validResultsForLoop = 'fuckyou'
// console.log('Watch');
// console.log(validResultsForLoop);

// // console.log( 'projectServicesNew' )
// // console.log( projectServicesNew )
// // console.log( 'prevProjectServices' )
// // console.log( prevProjectServices )
// // console.log( 'projectTopicsNew' )
// // console.log( projectTopicsNew )
// // console.log( 'prevProjectTopics' )
// // console.log( prevProjectTopics )
// // console.log('prevValidcomputedSelectResults before setting')
// // console.log(prevValidcomputedSelectResults)
// // validResultsForLoop = computedSelectResults.value
// // console.log('validResultsForLoop after setting')
// // console.log(validResultsForLoop)

// },{ deep: true })
</script>

<style>
#app .doDropdown .caret-vue {
  color: #385a82;
}
</style>

















